import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Grid, Stack, Typography, Box, Button} from 'views/components';
import {Translate, translate} from 'views/module';

import moment from 'moment';

const LiveInReview = (props) => {
  const newEvent = props.newEvent;
  const setIsStepValid = props.setIsStepValid;
  const daysOfWeek = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];

  React.useEffect(() => {
    setIsStepValid(true);
  }, []);

  return (
    <Grid item xs={12}>
      <Grid item xs={6}>
        <Stack>
          <Typography
            sx={{
              fontWeight: 600,
            }}
          >
            <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.EventDate.RecurrenceEvent.StartDate'/>
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
            }}
          >
            {moment(newEvent.liveInData.startDate).format('YYYY-MM-DD')}
          </Typography>
        </Stack>
      </Grid>
      <Grid item xs={6}>
        <Stack>
          <Typography
            sx={{
              fontWeight: 600,
            }}
          >
            <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.EventDate.RecurrenceEvent.EndDate'/>
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
            }}
          >
            {
              newEvent.liveInData.endDate &&
                moment(newEvent.liveInData.endDate).format('YYYY-MM-DD')
            }
            {
              !newEvent.liveInData.endDate &&
                translate('client.ClientDetail.Scheduling.ScheduleDetail.EventDate.RecurrenceEvent.Infinity')
            }
          </Typography>
        </Stack>
      </Grid>
      <Box>
        <Typography
          sx={{
            fontWeight: 600,
          }}
        >
          <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.EventDate.RecurrenceEvent.ByWeekday'/>
        </Typography>
        {
          daysOfWeek.map((day) => (
            <Button
              key={day}
              variant={newEvent.liveInData.byweekday.includes(day) ? 'contained' : 'outlined'}
              sx={{
                minWidth: '36px',
                height: '36px',
                borderRadius: '50%',
                fontSize: '16px',
                padding: '0',
                mr: 1,
              }}
            >
              {translate(`client.ClientDetail.Scheduling.ScheduleDetail.EventDate.RecurrenceEvent.DayOfTheWeek.${day}`)}
            </Button>
          ))
        }
      </Box>
    </Grid>

  );
};

LiveInReview.propTypes = {
  newEvent: PropTypes.object.isRequired,
  eventType: PropTypes.string.isRequired,
  setIsStepValid: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(LiveInReview));
